import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatApiError } from "@/lib/api";
import Header from "@/components/Header";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError(""); setLoading(true);
        try {
            await register(name, email, password);
            navigate("/inicio", { replace: true });
        } catch (err) {
            setError(formatApiError(err));
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen relative grain">
            <Header />
            <main className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16 pt-12 pb-24">
                <section className="hidden md:flex flex-col justify-center">
                    <div className="overline text-[#5C5C5C]">Comece sua jornada</div>
                    <h1 className="font-display font-light text-5xl mt-3 leading-tight">
                        <span className="font-editorial italic text-holo">7 dias</span> abertos<br/>para você.
                    </h1>
                    <p className="font-body text-[#5C5C5C] mt-6 max-w-md">
                        Acesso ilimitado a todas as jornadas e à biblioteca digital. Sem cobrança no período gratuito.
                    </p>
                </section>

                <section className="bg-white border border-black/5 rounded-3xl p-8 md:p-12">
                    <h2 className="font-display text-2xl tracking-tight">Criar minha conta</h2>
                    <p className="font-body text-sm text-[#5C5C5C] mt-1">É rápido. Você está a 30 segundos de começar.</p>

                    <form onSubmit={submit} className="mt-8 space-y-5">
                        <div>
                            <label className="overline text-[#5C5C5C]">Nome</label>
                            <input data-testid="register-name" value={name} onChange={(e)=>setName(e.target.value)} required minLength={2} className="imq-input mt-2" placeholder="Seu nome" />
                        </div>
                        <div>
                            <label className="overline text-[#5C5C5C]">E-mail</label>
                            <input data-testid="register-email" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required className="imq-input mt-2" placeholder="voce@email.com" />
                        </div>
                        <div>
                            <label className="overline text-[#5C5C5C]">Senha</label>
                            <input data-testid="register-password" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required minLength={6} className="imq-input mt-2" placeholder="Mínimo 6 caracteres" />
                        </div>
                        {error && (
                            <div data-testid="register-error" className="text-sm text-red-600 font-body bg-red-50 border border-red-100 px-3 py-2 rounded-lg">{error}</div>
                        )}
                        <button data-testid="register-submit" type="submit" disabled={loading} className="btn-primary w-full justify-center">
                            {loading ? "Criando..." : "Criar conta e começar"}
                        </button>
                    </form>

                    <div className="mt-8 text-sm font-body text-[#5C5C5C]">
                        Já tem conta?{" "}
                        <Link to="/login" data-testid="register-to-login" className="text-[#1A1A1A] underline underline-offset-4">Entrar</Link>
                    </div>
                </section>
            </main>
        </div>
    );
}
